import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import { HttpHandler } from 'app/shared/http/http-handler';
import { NotificationService } from 'app/shared/services/notification.service';
import { AppConfiguration } from 'app/shared/settings/app-config';
import { AppConfigService } from 'app/shared/settings/app-config.service';
import { forkJoin, interval, map, of, scan, Subject, takeWhile } from 'rxjs';
import { CodigoPastaEnum } from './enum/codigo-pasta.enum';

export class UploadArquivoService {
  private config: AppConfiguration = this.appSettings.getConfiguration();

  public privateContainerClient: ContainerClient;
  public privateBlobServiceClient: BlobServiceClient;
  public sasTokenPrivateContainer: any;
  public containerName: string;
  constructor(
    private appSettings: AppConfigService,
    private notification: NotificationService,
    private http: HttpHandler,
    private cdPasta: CodigoPastaEnum,
    private cdAuxiliar: number,
  ) {
    switch (cdPasta) {
      case CodigoPastaEnum.cpMp3Upload: this.containerName = 'mp3upload'; break;
      case CodigoPastaEnum.cpSpotUpload: this.containerName = 'spotupload'; break;
    }
  }

  public obterSASToken() {
    const urlApi = `${this.config.apiServiceBaseUri}v1/ca/sas/storage/${this.cdPasta}`;
    return this.http.get(`${urlApi}`);
  }
  public adicionarQueue(body) {
    const urlApi = `${this.config.apiServiceBaseUri}v1/ca/sas/adicionar-queue`;
    return this.http.post(`${urlApi}`, body);
  }

  async readAndInstanceAzureObjects(): Promise<any> {
    return forkJoin({
      getSasTokenPrivateContainer: (!this.sasTokenPrivateContainer ? this.obterSASToken() : of(this.sasTokenPrivateContainer)),
    }).toPromise().then(
      resultado => {
        this.sasTokenPrivateContainer = resultado.getSasTokenPrivateContainer;

        if (this.privateBlobServiceClient === undefined) {
          this.privateBlobServiceClient = new BlobServiceClient(`${this.config.azureBlobStorage}${this.sasTokenPrivateContainer}`);
        }
        if (this.privateContainerClient === undefined) {
          this.privateContainerClient = this.privateBlobServiceClient.getContainerClient(this.containerName);
        }
      }
    );
  }

  //Mocksalvar arquivos
  salvarArquivo(in1, in2) {
    console.log('Salvando Arquivo :' + in1);
    return new Promise<void>((resolve) => {
      if (in2) {
        // Criando o progresso em loop de 0% a 100% e de volta a 0%.
        const progresso$ = interval(300).pipe(
          scan((acc, _) => (acc.direcao === 'up' ? { ...acc, valor: acc.valor + 5 } : { ...acc, valor: acc.valor - 5 }), {
            valor: 0,
            direcao: 'up',
          }),
          map((estado) => {
            if (estado.valor >= 95) {
              estado.direcao = 'down';
            } else if (estado.valor <= 0) {
              estado.direcao = 'up';
            }
            return estado.valor;
          }),
          takeWhile((valor) => valor >= 0) // Continua enquanto o valor é válido
        );

        progresso$.subscribe({
          next: (porcentagem) => {
            in2.next({
              arquivo: in1.name,
              porcentagem,
            });
          },
          complete: () => resolve(),
        });
      } else {
        resolve();
      }
    });
  }

  async salvarDados(
    arquivo: File,
    progressoObserver?: Subject<any>) {
    // Efetua a chamada da função que fará leitura dos parametros / instancia do client / container do BlobStorage.
    // É passado como parâmetro de callback uma função delegate assincrona, para que possa efetuar a transmissao dos arquivos
    return this.readAndInstanceAzureObjects().then(async () => {
      // const nomeArquivo = arquivo.name.substring(arquivo.name.lastIndexOf('.') + 1);
      const nomeArquivo = arquivo.name;
      const novoNome = this.novoGuid() + '.mp3';
      const client = this.privateContainerClient.getBlockBlobClient(novoNome);

      return client.uploadData(arquivo, {
        blockSize: 256 * 1024, // 1MB block size
        concurrency: 1, // 20 concurrency
        blobHTTPHeaders: { blobContentType: arquivo.type },
        maxSingleShotSize: 1*1024*1024,
        onProgress: (p) => {
          if (progressoObserver) {
            console.log(p)
            progressoObserver.next({
              arquivo: nomeArquivo,
              porcentagem: Math.round(p.loadedBytes / arquivo.size * 100),
            });
          }
        }
      }).then((result) => {
        if (result._response.status === 201) {
          this.notification.sucesso(`Arquivo transmitido com sucesso ${nomeArquivo}.`);

          var params = {
            CodigoPasta: this.cdPasta,
            CodigoAuxiliar: this.cdAuxiliar.toString(),
            NomeArquivo: novoNome,
            LinkBlob: this.config.azureBlobStorage+novoNome,
            Adicionado: false,
            Retorno: ''
          };

          this.adicionarQueue(params).subscribe(res => {
            if (!res.adicionado) {
              this.notification.erro('Erro ao tentar adicionar à fila - ' + res.retorno)
            }
          })
        } else {
          this.notification.erro(`Não foi possível transmitir o arquivo ${nomeArquivo}.`);
        }
      });
    });
  }


  gerarS4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  novoGuid() {
    return this.gerarS4() + this.gerarS4() + this.gerarS4() + this.gerarS4() + this.gerarS4() + this.gerarS4() + this.gerarS4() + this.gerarS4();
  }
}
